import { logout, login } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  REVOKE_TOKEN,
  REVOKE_TOKEN_START,
  REVOKE_TOKEN_COMPLETE,
  REVOKE_TOKEN_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';

export function* revokeToken({}) {
  try {
    yield put({
      type: REVOKE_TOKEN_START,
    });
    
    const { refresh_token } = yield login.isAccessTokenValid();

    const { response, error } = yield call(logout.revokeToken, {
      refresh_token,
    });

    if (!!response) {
      yield put({
        type: REVOKE_TOKEN_COMPLETE,
        payload: {
          data: response.token,
        },
      });
    } else {
      yield put(
        onRevokeTokenError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onRevokeTokenError({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onRevokeTokenError = (payload = {}) => ({
  type: REVOKE_TOKEN_ERROR,
  payload,
});

function* watchRevokeToken() {
  yield takeLatest(REVOKE_TOKEN, revokeToken);
}

export const sagas = [watchRevokeToken];
